const LOCAL_API_URL = 'http://localhost/api';
const STAGING_API_URL = 'https://staging.apiapostatudo.com/api';
const PRODUCTION_API_URL = 'https://apiapostatudo.com/api';

export function getApostatudoApiUrl() {
  const host = window.location.hostname;

  const mapping = [
    { match: 'localhost', url: LOCAL_API_URL },
    { match: 'apostatudo-bet-br-homolog', url: STAGING_API_URL },
    { match: 'apostatudo.bet', url: PRODUCTION_API_URL },
  ];

  const entry = mapping.find((env) => host.includes(env.match));

  if (!entry) {
    console.error(
      `[getApostatudoApiUrl] - No API URL mapping found for host: ${host}`,
    );
  }

  return entry ? entry.url : 'http://localhost/api';
}
